import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';
import { UiSpinnerDirective } from '@app/shared/ui/spinner/ui-spinner.directive';

import { CooperationActionsService } from '@app/shared/services/actions/cooperation-actions.service';
import { CompaniesDataService } from '@app/shared/services/companies-data.service';
import { DialogService } from '@app/shared/services/shared/dialog.service';
import { Cooperation } from '@app/shared/types/models/cooperation/cooperation.model';
import { TranslatePipe } from '@ngx-translate/core';
import { CompanyCooperationsListItemComponent } from '../company-cooperations-list-item/company-cooperations-list-item.component';

@Component({
  selector: 'proffeo-company-cooperations-list',
  standalone: true,
  imports: [TranslatePipe, UiButtonComponent, CompanyCooperationsListItemComponent, UiSpinnerDirective],
  providers: [CooperationActionsService],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './company-cooperations-list.component.html'
})
export class CompanyCooperationsListComponent {
  private readonly dialogService = inject(DialogService);
  private readonly cooperationsActionsService = inject(CooperationActionsService);
  private readonly companiesDataService = inject(CompaniesDataService);

  public readonly companyId = input.required<string>();
  public readonly incoming = input<Cooperation[] | undefined>(undefined);
  public readonly outgoing = input<Cooperation[] | undefined>(undefined);

  protected onCreate(): void {
    this.companiesDataService.loadCompaniesForCooperation(this.companyId());
    const ref = this.dialogService.openCreateCooperationDialog({
      companies: this.companiesDataService.getCompaniesForCooperation()
    });
    ref?.afterClosed().subscribe(result => {
      if (result) {
        this.cooperationsActionsService.create(this.companyId(), result).subscribe();
      }
    });
  }
}
